<template>
  <div>
    <!-- //FILTRO -->
    <div class="row" v-if="!list">
      <div
        class="col-md-12 text-right"
        style="flex-wrap: wrap; margin-bottom: 10px"
      >
        <btn-rounded
          class="text-right"
          :label="'NOVO'"
          event="novo"
          :active-color="'success'"
        />

        <btn-rounded
          class="text-right"
          :label="filter ? 'LIMPAR' : 'FILTRO'"
          event="showFilter"
          :active-color="filter ? 'danger' : 'primary'"
        />
      </div>

      <div v-if="filter">
        <div class="row" style="padding: 5px" text-center>
          <!-- <div class="col-md-3">
            <fg-select
              :options="materialList"
              v-model="filterOptions.MaterialId"
              :selected="filterOptions.MaterialId"
              label="Tipo de Material"
            />
          </div> -->

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Inicial"
              :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Final"
              :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd"
            />
          </div>
        </div>

        <div class="row" style="padding: 5px" text-center>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Código, nome e descrição."
              placeholder="Código, nome e descrição..."
              v-model="filterOptions.term"
            />
          </div>
        </div>

        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded
                class="text-right"
                label="FILTRAR"
                event="activeFilter"
                active-color="success"
              />
            </div>
          </div>
        </div>
      </div>
      <div>

        
      </div>
    </div>
    <!-- FILTRO// -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table
            :title="table.title"
            :sub-title="table.subTitle"
            :data="list || carList"
            :columns="table.columns"
            :headers="table.headers"
            :control="table.control"
          />
        </div>
      </div>
    </div>

    <v-dialog />
  </div>
</template>

<script>
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(Carousel3d);

import moment from "moment";
const headers = [
  "/",
  "Código",
  "Usuário",
  "Contato",
  "E-mail",
  "Veículo",
  "Placa",
  "Km",
  "Descrição",
  "Valor",
  "Data Cadastrado",
  "Status",
  "Deletar",
];
const tableColumns = [
  {
    columnName: "CarImages",
    logic: function(data, columnData) {
      var find = true;
      if (!data) {
        find = false;
      } else if (!data.length) {
        find = false;
      } else if (!data.length > 0) {
        find = false;
      }

      if (find) {
        return `<img src="${data[0].imageThumbURL}" style="width:36px; height: 36px; border-radius: 50%; border: 2px solid black">`;
      } else {
        return '<img src="https://api.carrocash.com.br/image/render/thumb/default.png" style="width:36px; height: 36px; border-radius: 50%; border: 2px solid black"';
      }
    },
  },
  "code",
  "User.name",
  "User.formattedPhone",
  "User.email",
  "name",
  "plate",
  "mileage",
  "description",
  "formattedValueCentavos",
  {
    columnName: "createdAt",
    logic: function(data, columnData) {
      if (!data) {
        return "";
      }
      return moment
        .utc(data)
        .utcOffset(0)
        .format("D/M/YYYY H:mm:ss");
    },
  },
  {
    columnName: "isApproved",
    logic: function(data) {
      let className = "text-danger";
      let val = "Aguardando";
      if (data) {
        className = "text-success";
        val = "Aprovado";
      }
      let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;

      return `${prefix} ${val}`;
    },
  },
];
const control = [
  {
    event: "removeCar",
    class: "ti-trash btn btn-danger btn-sm",
  },
];

export default {
  components: {
    ComponentTable,
    Carousel3d,
    Slide,
  },

  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },

  computed: {
    ...mapState({
      carList: ({ car }) => car.list,

      materialList: ({ material }) =>
        material.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id,
          };
        }),
    }),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
  },

  methods: {
    ...mapActions(["getCarList", "deleteCar", "getMaterialList"]),

    // show(item) {
    //   this.CarImages = item;
    //   this.image = true;
    //   console.log(item);
    //   const viewer = this.$el.querySelector(".images").$viewer;
    //   viewer.show();
    // },

    // openCarousel(image, CarId) {
    //   this.CarImages = image;
    //   this.image = true;
    //   this.currentCarId = CarId;
    // },
    // closeCarousel() {
    //   this.image = false;
    //   this.current = 0;
    // },
    // selectSlide(index) {
    //   this.current = index;
    // },

    setPage: function(page) {
      this.page = page;
    },

    cleanFilter() {
      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }
      // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
      // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
      this.initData();
    },

    initData() {
      this.getCarList(this.filterOptions);
    },
  },

  created() {
    this.cleanFilter();

    this.$on("novo", () => {
      this.$router.push("/admin/anuncios/criar");
    });
    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });
    this.$on("activeFilter", () => {
      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "Minímo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
      // this.filter = !this.filter;
    });

    // this.$on("selectItem", (item, tableColumns) => {
    //   if (typeof tableColumns === "object") {
    //     console.log(item);
    //     this.image = true;
    //     if (this.CarImages.length > 0) {
    //       this.CarImages = [];
    //       this.current = 0;
    //       this.openCarousel(item.CarImages, item.id);
    //     } else {
    //       this.openCarousel(item.CarImages, item.id);
    //     }
    //     // this.selectSlide(this.current);
    //   } else {
    //     this.$router.push({
    //       name: "Anúncios - Editar",
    //       params: { id: item },
    //     });
    //   }
    // });

    this.$on("removeCar", (item) => {
      this.$modal.show("dialog", {
        title: "Excluir Carro",
        text: "Tem certeza que deseja excluir esse carro?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              this.deleteCar(item)
                .then((res) => {
                  this.$notify({
                    group: "foo",
                    title: "Sucesso",
                    text: res.msg,
                    position: "top center",
                    type: "success",
                  });
                  const index = this.carList.indexOf(item, 0);
                  if (index > -1) {
                    this.carList.splice(index, 1);
                  }
                })
                .catch((res) => {
                  this.$notify({
                    group: "foo",
                    title: res.msg,
                    text: res.info,
                    position: "top center",
                    type: "error",
                  });
                });

              this.$modal.hide("dialog");
            },
          },
          {
            title: "Não", // Button title
            handler: () => {
              this.$modal.hide("dialog");
            }, // Button click handler
          },
        ],
      });
    });
  },

  data() {
    return {
      page: 1,
      image: false,
      CarImages: [],
      timer: null,
      current: 0,
      table: {
        title: "Anúncios",
        subTitle: "Lista de veículos cadastrados",
        headers: [...headers],
        columns: [...tableColumns],
        control: [...control],
      },
      filter: false,
      filterOptions: {
        isAdmin: undefined,
        idActive: undefined,
        term: undefined,
        intervalStart: undefined,
        intervalEnd: undefined,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.close-button {
  border: none;
  width: 80px;
  height: 60px;
  text-align: center;
  align-items: center;
  margin-left: 55%;
  background-color: transparent;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Car/CarList.vue